function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.612 5.166l3.217-3.217c.68-.68 2.426-1.472 4.09.193 1.665 1.664.813 3.348.132 4.029l-4.423 4.423c-.712.712-2.47 1.675-4.184-.039",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.388 13.835L6.171 17.05c-.68.68-2.426 1.472-4.09-.193-1.665-1.664-.812-3.348-.132-4.029l4.423-4.423c.712-.712 2.47-1.675 4.184.039",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgGenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgGenerate;